<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-xl-row align-items-center justify-content-between gap-3 mb-4" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center">
          <div class="header-icon-wrapper mr-3" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);">
            <i class="fa fa-money text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Listagem Contas a Pagar</h4>
            <span class="text-muted small">Gestão de obrigações e pagamentos</span>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <!-- Filtro Consolidado Premium -->
          <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border">
            <b-button-group class="mr-1">
              <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir">
                <i class="fa fa-print"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Excel">
                <i class="fa fa-file-excel-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="CSV">
                <i class="fa fa-file-text-o"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-info" @click="abrirPainelAnalitico()" v-b-tooltip.hover title="Painel Analitico">
                <i class="fa fa-line-chart"></i>
              </b-button>
              <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                <i class="fa fa-ban"></i>
              </b-button>
            </b-button-group>

            <div class="d-flex align-items-center px-2 border-left mr-1">
              <cec-input-data ref="dt1" v-model="dt1" class="mx-1" style="width: 145px" placeholderText="Início" @keydown.enter.native="pesquisar()" />
              <span class="text-muted mx-1">até</span>
              <cec-input-data v-model="dt2" class="mx-1" style="width: 145px" placeholderText="Fim" @keydown.enter.native="pesquisar()" />
            </div>

            <div class="d-flex align-items-center px-2 border-left mr-1">
               <b-form-select class="border-0 bg-transparent py-0" v-model="tipoData" :options="optionsTipoData" style="width: 150px;" @keydown.enter.native="pesquisar()" />
            </div>

            <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm" @click="pesquisar()">
              <i class="fa fa-search mr-1"></i> FILTRAR
            </b-button>
          </div>

          <b-button variant="info" pill class="px-4 ml-2 font-weight-bold shadow-sm text-white" @click="novo()">
            <i class="fa fa-plus-circle mr-1"></i> Novo Título
          </b-button>
        </div>
      </div>

      <!-- Filtros Avançados Modernos -->
      <b-collapse v-model="filtro.avancado">
        <b-card class="card-filter-premium mb-4 border-0 shadow-sm" :class="{'bg-dark text-white': isDark}">
          <div class="modal-section-title mb-3" :class="{'text-white border-secondary': isDark}">Parâmetros Adicionais de Filtro</div>
          <b-row align-v="end">
            <b-col md="2">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Nº Documento</label>
              <b-form-input v-model="documento" placeholder="Ex: 12345" class="rounded-pill shadow-xs border-0 bg-light" @keydown.enter.native="pesquisar()" />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Nº Controle (ID)</label>
              <b-form-input v-model="id" placeholder="Ex: 987" class="rounded-pill shadow-xs border-0 bg-light" @keydown.enter.native="pesquisar()" />
            </b-col>
            <b-col md="2">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Período por</label>
              <b-form-select v-model="tipoData" :options="optionsTipoData" class="rounded-pill shadow-xs border-0 bg-light" @keydown.enter.native="pesquisar()" />
            </b-col>
            <b-col md="6">
              <label class="modal-label-premium" :class="{'text-light': isDark}">Fornecedor</label>
              <cliente-pesquisa 
                @retornaId="clienteId = $event"
                :idInicial="clienteId"
                label=""
                place="Informe o Fornecedor..."
                labelBotao=""
                ref="clientepesquisa"
                idModal="clientepesquisa"
                input-class="rounded-pill shadow-xs border-0 bg-light"
                @keydown.enter.native="pesquisar()"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-collapse>
    
      <!-- Resumo Financeiro Premium -->
      <b-row class="mb-4 px-3">
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-primary" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Títulos</div>
            <div class="h4 mb-0 font-weight-bold">{{ quantTitulos }}</div>
          </div>
        </b-col>
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-info" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Total Títulos</div>
            <div class="h4 mb-0 font-weight-bold">
              <vue-autonumeric :disabled="true" :options="'commaDecimalCharDotSeparator'" v-model="totalTitulos" tag="span" />
            </div>
          </div>
        </b-col>
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-success" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Em Dias</div>
            <div class="h4 mb-0 font-weight-bold text-success">
              <vue-autonumeric :disabled="true" :options="'commaDecimalCharDotSeparator'" v-model="totalEmDias" tag="span" />
            </div>
          </div>
        </b-col>
        <b-col md="3">
          <div class="bg-white p-3 rounded shadow-xs border-left border-danger" :class="{'bg-dark border-secondary text-white': isDark}" style="border-left-width: 4px !important;">
            <div class="text-muted small text-uppercase font-weight-bold" :class="{'text-light': isDark}">Atrasados</div>
            <div class="h4 mb-0 font-weight-bold text-danger">
              <vue-autonumeric :disabled="true" :options="'commaDecimalCharDotSeparator'" v-model="totalAtrasado" tag="span" />
            </div>
          </div>
        </b-col>
      </b-row>
      <!--  -----------------------------------------------------------------------------------
                                      TABELA DE LISTAGEM - FILTRO 
            ----------------------------------------------------------------------------------- -->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    class="mb-0 table-finance"
                    id="tbl-principal"
                    ref="tbl"
                    show-empty
                    empty-text="Informe o filtro para ver os pesquisas "
                    :dark="isDark"
                    small
                    responsive 
                    :tbody-tr-class="rowClassSelecionado"
                    :head-variant="isDark ? 'dark' : 'light'"
                    hover 
                    :sticky-header="stickyHeight"
                    @row-clicked="clicarLinha"
                    @row-dblclicked="edit"
                    :items="itensFiltrados" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                  >
            <!-- Cabeçalho: DOCUMENTO -->
            <template #head(DOCUMENTO)>
              <SetFilter
                label="Documento"
                v-model="filtros.DOCUMENTO"
                :options="opcoes.DOCUMENTO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(NUMERO_EXTERNO)>
              <SetFilter
                label="Externo"
                v-model="filtros.NUMERO_EXTERNO"
                :options="opcoes.NUMERO_EXTERNO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>

            <!-- Cabeçalho: Situação -->
            <template #head(PARCELAS)>
              <SetFilter
                label="Parcela"
                v-model="filtros.PARCELAS"
                :options="opcoes.PARCELAS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(COD_FORNEC)>
              <SetFilter
                label="F.ID"
                v-model="filtros.COD_FORNEC"
                :options="opcoes.COD_FORNEC"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(NOME_FORNECEDOR)>
              <SetFilter
                label="Fornecedor"
                v-model="filtros.NOME_FORNECEDOR"
                :options="opcoes.NOME_FORNECEDOR"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            
            <template #head(ITENS)>
              <SetFilter
                label="Descricao"
                v-model="filtros.ITENS"
                :options="opcoes.ITENS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(DT_DOC)>
              <SetFilter
                label="Doc"
                v-model="filtros.DT_DOC"
                :options="opcoes.DT_DOC"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>
            <template #head(DT_VENC)>
              <SetFilter
                label="Vencimento"
                v-model="filtros.DT_VENC"
                :options="opcoes.DT_VENC"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #head(DIAS_ATRASO)>
              <SetFilter
                label="Atraso "
                v-model="filtros.DIAS_ATRASO"
                :options="opcoes.DIAS_ATRASO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #head(VL_DOC)>
              <SetFilter
                label="Vl. Doc "
                v-model="filtros.VL_DOC"
                :options="opcoes.VL_DOC"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #head(VL_AJUSTE)>
              <SetFilter
                label="VL. Ajuste"
                v-model="filtros.VL_AJUSTE"
                :options="opcoes.VL_AJUSTE"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #head(VL_RESTANTE)>
              <SetFilter
                label="Vl. Aberto "
                v-model="filtros.VL_RESTANTE"
                :options="opcoes.VL_RESTANTE"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'gray-200'"
              />
            </template>      
            <template #cell(DOCUMENTO)="item">
              <div class="font-weight-bold text-dark">
                {{item.item.DOCUMENTO}}
              </div>
              <div class="small text-muted">
                <span>
                  Parc: {{item.item.PARCELAS}}
                </span>
              </div>
            </template>
            <template #cell(ITENS)="item">
              <div class="text-truncate" style="max-width: 200px;" :title="item.item.ITENS">
                {{item.item.ITENS}}
              </div>
            </template>
            <template #cell(NOME_FORNECEDOR)="item">
              <div class="font-weight-bold text-primary">
                {{item.item.NOME_FORNECEDOR}}
              </div>
              <div class="small text-muted">
                ID: {{item.item.COD_FORNEC}}
              </div>
            </template>
            <template #cell(DIAS_ATRASO)="item">
                <b-badge pill class="px-3 py-1 shadow-xs" :variant="colorirDiasAtraso(item.item.DIAS_ATRASO)">{{item.item.DIAS_ATRASO}}</b-badge>
              </template>      
            <template #cell(actions)="item">
              <div class="d-flex align-items-center gap-1">
                <b-button v-if="(item.item.VL_DOC !== item.item.VL_APAGAR)"
                      type="button" @click.stop.prevent="abrirModalPagamentos(item.item)" size="sm" variant="soft-primary" pill class="btn-icon-only shadow-sm mr-1" title="Pagamentos" v-b-tooltip.hover.left >
                  <i class="fa fa-exchange"></i>
                </b-button>

                <b-button type="button" @click="abrirModalCancelamento(item.item)" size="sm" variant="soft-danger" pill class="btn-icon-only shadow-sm mr-1" title="Cancelar Titulo" v-b-tooltip.hover.left>
                  <i class="fa fa-close"></i>
                </b-button>

                <b-button type="button" @click="abrirModalBaixar(item.item)" size="sm" variant="soft-success" pill class="btn-icon-only shadow-sm" title="Baixar Título" v-b-tooltip.hover.left>
                  <i class="fa fa-money"></i>
                </b-button>
              </div>
            </template>
            <template #custom-foot="{ fields }">
              <b-tr class="bg-light font-weight-bold">
                <b-td colspan="8" class="text-right">TOTAIS:</b-td>
                <b-td class="text-right">{{ vlDocRodape }}</b-td>
                <b-td class="text-right text-info">{{ vlAjusteRodape }}</b-td>
                <b-td class="text-right text-primary">{{ vlRestanteRodape }}</b-td>
                <b-td></b-td>
              </b-tr>
            </template>
          </b-table>
          </div>
        </b-col>
      </b-row>
      <div>
        <!--  -----------------------------------------------------------------------------------
                                            MODAL PAGAMENTOS 
              ----------------------------------------------------------------------------------- -->
          <b-modal ref="modal-baixar" 
              id="modal-baixar" 
              hide-header
              hide-footer
              body-class="p-0 overflow-hidden"
              content-class="border-0 shadow-lg"
              centered
              size="lg"
              @shown="focusModalPagar()" 
          >
            <b-overlay :show="overlayBaixando" 
                        no-wrap 
                        fixed 
                        z-index="1100" 
                        spinner-variant="primary"
                        spinner-type="border">
              <template #overlay>
                <div class="text-center bg-white p-4 rounded shadow-lg border">
                  <b-icon icon="stopwatch" font-scale="3" class="text-primary mb-3" animation="cylon"></b-icon>
                  <h5 class="font-weight-bold">Processando Pagamento...</h5>
                  <p class="text-muted mb-0">Por favor, aguarde um momento.</p>
                </div>
              </template>
            </b-overlay>

            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
                <div class="header-icon-wrapper mr-3 bg-white-10">
                    <i class="fa fa-money text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Baixar Título a Pagar</h5>
                    <small class="text-white opacity-75">Confirmação de saída financeira do caixa/banco</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-baixar')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>

            <div class="p-4 bg-white">
                <!-- Modal Info Bar -->
                <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                    <b-row align-v="center">
                        <b-col md="6">
                            <small class="modal-label-premium">Fornecedor</small>
                            <h5 class="mb-0 font-weight-bold text-dark">{{pago.nomeCliente}}</h5>
                        </b-col>
                        <b-col md="3" class="border-left">
                            <small class="modal-label-premium">Documento / Venc.</small>
                            <h5 class="mb-0 font-weight-bold text-primary">{{pago.documento}}</h5>
                            <small class="text-muted font-weight-bold">{{pago.dataVencimento}}</small>
                        </b-col>
                        <b-col md="3" class="border-left text-right">
                            <small class="modal-label-premium">Valor Original</small>
                            <h5 class="mb-0 font-weight-bold text-success">{{formatCurrency(pago.valorDocumento)}}</h5>
                        </b-col>
                    </b-row>
                </div>

                <div class="modal-section-title mb-3">
                    <i class="fa fa-cogs mr-2 text-primary"></i> Detalhes do Pagamento
                </div>
                
                <div class="p-4 bg-light rounded border shadow-xs mb-4">
                    <b-row class="mb-3">
                        <b-col md="6">
                            <label class="modal-label-premium">Tipo de Pagamento</label>
                            <b-form-select id="tipoPagamento" ref="tipoPagamento"
                                v-model="pago.tipoPagamento"
                                :options="tipoPagamentoOpcoes"
                                class="rounded-pill shadow-xs"
                            ></b-form-select>
                        </b-col>
                        <b-col md="6">
                            <label class="modal-label-premium">Data do Pagamento</label>
                            <b-form-input type="date" 
                                id="dataBaixa" 
                                v-model="pago.dataMovimento"
                                class="rounded-pill shadow-xs"
                            ></b-form-input>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col md="6">
                            <label class="modal-label-premium">Valor Pago R$</label>
                            <div class="d-flex gap-2">
                                <vue-autonumeric
                                    id="valorPagos" 
                                    ref="valorPagos"
                                    v-model="pago.valorPago"
                                    :options="'Brazilian'"
                                    :class="['form-control rounded-pill shadow-xs', { 'is-invalid': !validouCamposGeralBaixa }]" 
                                    style="text-align: right"
                                ></vue-autonumeric>
                                <b-button variant="soft-primary" pill class="px-3 font-weight-bold" @click="usarRestante()" title="Usar valor restante">
                                    <i class="fa fa-magic"></i>
                                </b-button>
                            </div>
                        </b-col>
                        <b-col md="6">
                            <label class="modal-label-premium">Multa e Juros R$</label>
                            <vue-autonumeric  
                                id="valorAjustes" 
                                v-model="pago.valorAjustes" 
                                :options="'Brazilian'" 
                                class="form-control rounded-pill shadow-xs" 
                                style="text-align: right"
                            ></vue-autonumeric>
                        </b-col>
                    </b-row>

                    <b-row class="mb-3">
                        <b-col md="12">
                            <label class="modal-label-premium">Histórico do Caixa <span class="text-danger">*</span></label>
                            <historico-caixa-dropdown
                                v-model="pago.historicoId"
                                tipo="DEBITO"
                                :state="!!pago.historicoId"
                                class="rounded-pill shadow-xs"
                                placeholder="Selecione o histórico..."
                            />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <label class="modal-label-premium">Conta de Origem</label>
                            <b-form-select   
                                v-model="pago.contaId" 
                                :options="contasOpcoes" 
                                ref="comboconta"
                                class="rounded-pill shadow-xs"
                            >
                                <template slot="first">
                                    <option :value="null">-- Selecione a conta bancária --</option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-row>

                    <!-- Campos específicos para PIX -->
                    <div v-if="pago.tipoPagamento === '6'" class="mt-3">
                        <div class="modal-section-title mb-3">
                            <i class="fa fa-qrcode mr-2 text-primary"></i> Dados do PIX
                        </div>
                        
                        <b-row class="mb-3">
                            <b-col md="6">
                                <label class="modal-label-premium">Tipo de Chave PIX <span class="text-danger">*</span></label>
                                <b-form-select
                                    v-model="pago.tipoChavePix"
                                    :options="tipoChavePixOpcoes"
                                    :state="!!pago.tipoChavePix"
                                    class="rounded-pill shadow-xs"
                                >
                                    <template slot="first">
                                        <option :value="null">-- Selecione o tipo de chave --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="6">
                                <label class="modal-label-premium">Nome do Pagador</label>
                                <b-form-input
                                    v-model="pago.nomePagadorPix"
                                    placeholder="Nome completo do pagador"
                                    class="rounded-pill shadow-xs"
                                    maxlength="100"
                                ></b-form-input>
                            </b-col>
                        </b-row>

                        <b-row class="mb-3">
                            <b-col md="12">
                                <label class="modal-label-premium">Banco de Origem</label>
                                <b-form-select
                                    v-model="pago.bancoPixId"
                                    :options="bancosPixOpcoes"
                                    class="rounded-pill shadow-xs"
                                >
                                    <template slot="first">
                                        <option :value="null">-- Selecione o banco de origem --</option>
                                    </template>
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <div class="modal-section-title mb-3">
                    <i class="fa fa-money mr-2 text-primary"></i> Resumo de Saldos
                </div>
                
                <b-row>
                    <b-col md="3">
                        <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                            <small class="modal-label-premium">Vlr. Original</small>
                            <h5 class="mb-0 font-weight-bold text-dark">{{formatCurrency(pago.valorDocumento)}}</h5>
                        </div>
                    </b-col>
                    <b-col md="3">
                        <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                            <small class="modal-label-premium">Pagamentos</small>
                            <h5 class="mb-0 font-weight-bold text-info">{{formatCurrency(pago.valorPagamentos)}}</h5>
                        </div>
                    </b-col>
                    <b-col md="3">
                        <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                            <small class="modal-label-premium">Ajustes</small>
                            <h5 class="mb-0 font-weight-bold text-warning">{{formatCurrency(pago.valorAjustes)}}</h5>
                        </div>
                    </b-col>
                    <b-col md="3">
                        <div class="p-3 bg-white rounded border shadow-sm text-center h-100 border-success border-2">
                            <small class="modal-label-premium text-success">Vlr. Restante</small>
                            <h4 class="mb-0 font-weight-bold text-success">{{formatCurrency(pago.valorRestante)}}</h4>
                        </div>
                    </b-col>
                </b-row>
            </div>

            <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
                <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-baixar')">
                    CANCELAR
                </b-button>
                <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" @click="baixar()">
                    <i class="fa fa-check-circle mr-1"></i> CONFIRMAR PAGAMENTO
                </b-button>
            </div>
          </b-modal>
      </div>
      <!--  -----------------------------------------------------------------------------------
                                      MODAL PAGAMENTOS 
      ----------------------------------------------------------------------------------- -->
      <div>
        <b-modal ref="modal-pagamentos" 
            id="modal-pagamento" 
            centered
            no-close-on-esc 
            no-close-on-backdrop
            hide-header-close
            hide-header
            body-class="p-0"
            size="lg"
            headerClass= "p-2 border-bottom-0" 
            title="Lista de Pagamentos" >
        
          <b-card bg-variant="light">
              <div slot="header">
                  <i class='fa fa-align-justify'></i><strong>  Pagamentos do Título</strong>
              </div>
                  
              <!--  -----------------------------------------------------------------------------------
                                          TABELA DE PAGAMENTOS
                    ----------------------------------------------------------------------------------- -->
          
              <b-table class="table table-sm"
                      show-empty
                      empty-text="Informe o filtro para ver os pesquisas "
                      stacked="md"
                      small
                      foot-clone
                      responsive 
                      striped 
                      hover 
                      :busy.sync="isBusyListagem" 
                      :items="tablePagamentosItens" 
                      :fields="tablePagamentosFields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      
                      >
                <template #cell(actions)="item">
                  <b-button type="button" @click.stop.prevent="onAbrirOverlayPagamentos(item.item)" size="sm" variant="warning" title="Estornar" v-b-tooltip.hover >
                    <i class="fa fa-times"></i>
                  </b-button>
                </template>
                <template #foot(VL_BAIXA)="">
                  <span class="text-info">{{somaTotalPago}}</span>
                </template>
                <template #foot(DT_BAIXA)="">
                  {{ }}
                </template>
                <template #foot(USUARIO)="">
                  {{ }}
                </template>
                <template #foot(actions)="">
                  {{ }}
                </template>
              </b-table>
          </b-card>

          <template #modal-footer="{ cancel }">
              <b-button  :disabled="parametrosOverlayPagamento.busy"   variant="danger" @click="cancel()">
                Fechar
              </b-button>
          </template>
              <!--  -----------------------------------------------------------------------------------
                                          OVERLAY DO ESTORNO DO PAGAMENTO 
                    ----------------------------------------------------------------------------------- -->
              <b-overlay :show="parametrosOverlayPagamento.busy" 
                          no-wrap 
                          @shown="onShownOverlayPagamentos()">
                <template #overlay>
                  <div v-if="parametrosOverlayPagamento.processando" class="text-center p-4">
                    <b-icon icon="icon-clock" font-scale="4"></b-icon>
                    <div class="mb-3">Processando a requisição...</div>
                    <div class="d-flex justify-content-center mb-3">
                        <b-spinner label="Loading..."></b-spinner>
                    </div>
                  </div>
                  <div
                    v-else
                    ref="dialogOverlayPagamentos"
                    tabindex="-1"
                    role="dialog"
                    aria-modal="false"
                    aria-labelledby="form-confirm-label"
                    class="text-center p-3">
                    <p class="text-left" ><strong>DOCUMENTO: </strong> {{parametrosOverlayPagamento.documento}} <strong>  PARCELA: </strong>{{parametrosOverlayPagamento.parcela}}</p>
                    <p class="text-left" ><strong>VALOR: {{parametrosOverlayPagamento.valor}}</strong></p>
                    <div v-if="parametrosOverlayPagamento.permissao">
                      <p ><strong>PERMISSÂO PARA ESTORNAR AUTORIZADA</strong></p>
                      <hr>
                      <p><strong id="form-confirm-label">Voce tem certeza?</strong></p>
                    </div>
                    <div v-else>
                      <p><strong>NÃO TEM PERMISSAO PARA ESTORNAR!!!!</strong></p>
                      <hr>
                    </div>
                    <div class="text-center">
                      <b-button variant="outline-danger" class="mr-3" @click="onCancelOverlayPagamentos()">
                        Voltar
                      </b-button>
                      <b-button v-if="parametrosOverlayPagamento.permissao" variant="outline-success" @click="onOKOverlayPagamentos()">Estornar</b-button>
                    </div>
                  </div>
                </template>
              </b-overlay>
        </b-modal>
      </div>
      <div>
      <!--  -----------------------------------------------------------------------------------
                                          MODAL CANCELAMENTO 
            ----------------------------------------------------------------------------------- -->
        <b-modal ref="modal-cancelamento" 
            id="modal-cancelamento" 
            hide-header
            hide-footer
            body-class="p-0 overflow-hidden"
            content-class="border-0 shadow-lg"
            centered
            size="lg"
            @shown="focusModalCancelamento()" 
        >
          <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                      no-wrap 
                      fixed 
                      z-index="1100" 
                      spinner-variant="primary"
                      spinner-type="border">
            <template #overlay>
              <div class="text-center bg-white p-4 rounded shadow-lg border">
                <b-icon icon="stopwatch" font-scale="3" class="text-danger mb-3" animation="cylon"></b-icon>
                <h5 class="font-weight-bold">Processando Cancelamento...</h5>
                <p class="text-muted mb-0">Por favor, aguarde um momento.</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #f86c6b 0%, #dc3545 100%) !important;">
                <div class="header-icon-wrapper mr-3 bg-white-10">
                    <i class="fa fa-times-circle text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Cancelar Título a Pagar</h5>
                    <small class="text-white opacity-75">Confirmação de cancelamento definitivo</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-cancelamento')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
          </div>

          <div class="p-4 bg-white">
               <!-- Info Bar -->
               <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                    <b-row align-v="center">
                        <b-col md="6">
                            <small class="modal-label-premium">Fornecedor</small>
                            <h5 class="mb-0 font-weight-bold text-dark">{{cancelamento.dados.nomeCliente}}</h5>
                        </b-col>
                        <b-col md="3" class="border-left">
                            <small class="modal-label-premium">Documento / Venc.</small>
                            <h5 class="mb-0 font-weight-bold text-primary">{{cancelamento.dados.documento}} - {{cancelamento.dados.parcela}}</h5>
                            <small class="text-muted font-weight-bold">{{cancelamento.dados.dataVencimento}}</small>
                        </b-col>
                        <b-col md="3" class="border-left text-right">
                            <small class="modal-label-premium">Valor Original</small>
                            <h5 class="mb-0 font-weight-bold text-success">{{cancelamento.dados.valorDocumento}}</h5>
                        </b-col>
                    </b-row>
                </div>

                <div v-if="cancelamento.parametros.permissao === false" class="alert alert-danger shadow-sm border-0 text-center p-4">
                     <i class="fa fa-lock fa-3x mb-3 text-danger opacity-50"></i>
                     <h5 class="font-weight-bold text-danger">Acesso Negado</h5>
                     <p class="mb-0">Seu usuário não possui permissão para cancelar títulos.</p>
                </div>

                <div v-else>
                     <div class="modal-section-title mb-3">
                        <i class="fa fa-edit mr-2 text-primary"></i> Justificativa
                    </div>
                    
                    <div class="p-4 bg-light rounded border shadow-xs mb-4">
                        <b-row>
                             <b-col md="12">
                                <label class="modal-label-premium" for="motivoCancelamento">Motivo do Cancelamento</label>
                                <b-form-input type="text" 
                                              ref="motivoCancelamento" 
                                              id="motivoCancelamento" 
                                              v-model="cancelamento.dados.motivo" 
                                              :state="validouCampo_motivoCancelamento"
                                              placeholder="Descreva o motivo do cancelamento..." 
                                              class="rounded-pill shadow-xs p-4"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                    </div>
                </div>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
            <b-button variant="soft-dark" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-cancelamento')">
               FECHAR
            </b-button>
            <b-button v-if="cancelamento.parametros.permissao === true" variant="danger" pill class="px-5 font-weight-bold shadow-sm" @click="cancelar()">
               <i class="fa fa-trash-o mr-1"></i> CONFIRMAR CANCELAMENTO
            </b-button>
          </div>
        </b-modal>
      </div>
    </div>
    
    <!-- Modal de Confirmação para Resultados Grandes -->
    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import moment from 'moment'
import {Money} from 'v-money'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import HistoricoCaixaDropdown from '@/views/componentes/dropdown/HistoricoCaixaDropdown.vue'


export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    Money,
    VueAutonumeric,
    SetFilter,
    ModalAlertaResultadoGrande,
    CecInputData,
    HistoricoCaixaDropdown
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    preferVh: 62,
    useExternalPaging: true,
    filters: [
      { key: 'DOCUMENTO', type: 'string', label: 'Documento' },
      { key: 'NUMERO_EXTERNO', type: 'string', label: 'Externo' },
      { key: 'PARCELAS', type: 'string', label: 'Parcela' },
      { key: 'COD_FORNEC', type: 'string', label: 'F.ID' },
      { key: 'NOME_FORNECEDOR', type: 'string', label: 'Fornecedor' },
      { key: 'USUARIO_CADASTRO', type: 'string', label: 'Cad.' },
      { key: 'USUARIO_ALTERACAO', type: 'string', label: 'Alt.' },
      { key: 'ITENS', type: 'string', label: 'Descrição' },
      { key: 'DT_DOC', type: 'date', label: 'Dt. Doc'},
      { key: 'DT_VENC', type: 'date', label: 'Vencimento'} ,
      { key: 'DIAS_ATRASO', type: 'number', label: 'Atraso'} ,
      { key: 'VL_DOC', type: 'number', label: 'VL. Doc'} ,
      { key: 'VL_AJUSTE', type: 'number', label: 'Vl. Ajuste'} ,
      { key: 'VL_RESTANTE', type: 'number', label: 'Vl. Aberto'},
    ]
  })],
  data () {
    return {
    filtro: {
        avancado: false
      },
      show: false,
      minimoMoeda: 0,
      overlayBaixando: false,
      overlayPagamentos: false,
      parametrosOverlayPagamento: {
        busy: false,
        processando: false,
        counter: 1,
        interval: null,
        permissao: true,
        valor: 0.00,
        parcela: '',
        documento: '',
        apagarId: null,
        pagoId: null
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          titulo: null,
          id: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataVencimento: 0.00,
          gta: '',
          valorDocumento: 0.00,
          usuario: ''
        }
      },
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      optionsTipoData: [
        { value: 'D', text: 'Data do Documento' },
        { value: 'V', text: 'Data do Vencimento' }
      ],
      isLoading: false,
      status: '',
      isBusyListagem: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      tituloSelecionadoKey: null,
      fields: [
        {
          key: "DOCUMENTO",
          label: 'Documento',
          class:'text-right p-0 align-middle',
          sortable: true
        },
        {
          key: "NUMERO_EXTERNO",
          label: 'Externo',
          class:'text-right p-0 align-middle',
          sortable: true
        },
        {
          key: "ITENS",
          label: 'Descrição',
          class:'p-0 align-middle',
          sortable: true
        },
        {
          key: "COD_FORNEC",
          label: 'F.ID',
          class:'text-right p-0 align-middle',
          sortable: true
        },
        {
          key: "NOME_FORNECEDOR",
          label: 'Fornecedor',
          class:'p-0 align-middle',
          sortable: true
        },
        {
          key: "USUARIO_CADASTRO",
          label: 'Cad.',
          class:'p-0 align-middle',
          sortable: true,
          formatter: (value, key, item) => value || '-'
        },
        {
          key: "USUARIO_ALTERACAO",
          label: 'Alt.',
          class:'p-0 align-middle',
          sortable: true,
          formatter: (value, key, item) => value || '-'
        },
        {
          key: "DT_DOC",
          label: 'Docto.', 
          sortable: true,
          class:'text-right p-0 align-middle',
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "DT_VENC",
          label: 'Vencimento', 
          sortable: true,
          class:'text-right p-0 align-middle',
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "DIAS_ATRASO",
          label: 'Atrazo',
          class:'text-center p-0 align-middle',
          sortable: true
        },
        {
          key: 'VL_DOC', 
          class:'text-right p-0 align-middle',
          label: 'Original (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: 'VL_AJUSTE', 
          class:'text-right p-0 align-middle',
          label: 'Ajustes (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: 'VL_RESTANTE', 
          class:'text-right p-0 align-middle',
          label: 'Restante (R$)', 
          sortable: true,
          formatter: (value, key, item) => 
            (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: "actions" ,
          label: 'Ações',
          class:'text-right p-0 align-middle',
          thStyle: { width: "10%" }
        }
      ],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' },
      tipoPagamentoOpcoes: [
        { value: '0', text: 'Dinheiro\Carteira' },
        { value: '1', text: 'Depósito Bancário' },
        { value: '2', text: 'Boleto' },
        { value: '3', text: 'Cheque' },
        { value: '4', text: 'Cartão de Crédito' },
        { value: '6', text: 'PIX' }
      ],
      tipoChavePixOpcoes: [
        { value: '0', text: 'CPF/CNPJ' },
        { value: '1', text: 'Celular' },
        { value: '2', text: 'Email' },
        { value: '3', text: 'Aleatória' }
      ],
      bancosPixOpcoes: [],
      pago: {
        apagarId: null,
        documento: null,
        parcela: null,
        clienteId: null,
        nomeCliente: null,
        dataVencimento: "00/00/0000",
        dataMovimento: "00/00/0000",
        tipoPagamento: '0',
        valorPago: 0.00,
        valorPagamentos: 0.00,
        valorAjustes: 0.00,
        valorDocumento: 0.00,
        valorRestante: 0.00,
        valorAberto: 0.00,
        contaId: null,
        vendedorId: null,
        usuario: window.localStorage.getItem('login'),
        tipoChavePix: null,
        nomePagadorPix: null,
        bancoPixId: null,
        historicoId: null
      },
      contasOpcoes: [],
      tablePagamentosItens: [],
      tablePagamentosFields: [
        {
          key: "DT_BAIXA",
          label: 'Data Pagamento', 
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: 'VL_PAGO', 
          class:'text-right', 
          label: 'Valor Pago (R$)', 
          formatter: (value, key, item) => 
            value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        },
        {
          key: "USUARIO",
          label: 'Usuário',
        },
        {
          key: "actions" ,
          label: 'Ações',
          class:'text-right p-0',
          class:'text-right' 
        }
      ],
      somaTotalPago: 0.00
    }
  },
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    perPage: {
      get () {
        return this.$store.getters['apagar/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('apagar/SET_PER_PAGE', Number(v) || 25)
      }
    },
    currentPage: {
      get () {
        return this.$store.getters['apagar/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_PAGINA_ATUAL", value);
      }
    },
    dt1: {
      get () {
        return this.$store.getters['apagar/DT1']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['apagar/DT2']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['apagar/ID']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_ID", value);
      }
    },
    documento: {
      get () {
        return this.$store.getters['apagar/DOCUMENTO']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_DOCUMENTO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['apagar/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_CLIENTE_ID", value);
      }
    },
    tipoData: {
      get () {
        return this.$store.getters['apagar/TIPO_DATA']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_TIPO_DATA", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['apagar/LISTA']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_LISTA", value);
      }
    },
    totalTitulos: {
      get () {
        return this.$store.getters['apagar/TOTAL_TITULOS']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_TOTAL_TITULOS", value);
      }
    },
    totalEmDias: {
      get () {
        return this.$store.getters['apagar/TOTAL_EM_DIAS']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_TOTAL_EM_DIAS", value);
      }
    },
    totalAtrasado: {
      get () {
        return this.$store.getters['apagar/TOTAL_ATRASADO']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_TOTAL_ATRASADO", value);
      }
    },
    quantTitulos: {
      get () {
        return this.$store.getters['apagar/QUANT_TITULOS']
      }, 
      set (value) {
        this.$store.commit("apagar/SET_QUANT_TITULOS", value);
      }
    },
    vlRestanteRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_RESTANTE) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    vlAjusteRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_AJUSTE) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    vlDocRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_DOC) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    validouCamposGeralBaixa () {      
      let retorno = true
      if ( this.pago.valorPago === null || this.pago.valorPago <= 0.00 || this.pago.valorRestante < 0.00  ) { retorno = false}
      if ( !this.pago.historicoId ) { retorno = false}           
      return retorno     
    },
    validouCampo_motivoCancelamento () {      
      let retorno = null
      if (this.cancelamento.dados.motivo === ''  || this.cancelamento.dados.motivo === null)   { retorno = false }
      return  retorno
    }
  },
  methods: {
    abrirPainelAnalitico() {
      this.$router.push('/movimentos/contasapagar/analytics')
    },
     /**************************************************************************************************
     * *************** MODAL CANCELAMENTO **************************************************************
     * *************************************************************************************************/
    async abrirModalCancelamento(titulo) {
      this.cancelamento.dados.titulo = titulo
      this.cancelamento.dados.id = titulo.SEQUENCIA
      this.cancelamento.dados.nomeCliente = titulo.NOME_FORNECEDOR
      this.cancelamento.dados.documento = titulo.DOCUMENTO
      this.cancelamento.dados.parcela = titulo.PARCELAS
      this.cancelamento.dados.motivo = ''
      this.cancelamento.dados.dataVencimento = moment(String(titulo.DT_VENC)).format('DD/MM/YYYY')
      this.cancelamento.dados.valorDocumento = titulo.VL_APAGAR.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      this.cancelamento.dados.usuario = window.localStorage.getItem('login')

      try {
        this.$store.commit('controle/setAguardando', true)
        
        const permissaoPayLoad = {
          login: window.localStorage.getItem('login'),
          permissao: 'AcPropExcluirApagar'
        }

        let permissaoResult = null
        try {
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.estorno.parametros.permissao = false
          Tools.exibirMensagem(this.$store, 'Permissão', 'warning', 'Usuário não autorizado')
        }              

        this.cancelamento.parametros.permissao = true
        this.cancelamento.parametros.processando = false
        this.cancelamento.parametros.busy = true
        this.$refs['modal-cancelamento'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focusModalCancelamento() {
      this.$refs.motivoCancelamento.focus()
    },
    cancelar() {
      if (this.validouCampo_motivoEstorno) {
        this.$root.$bvToast.toast('Informe o motivo' , {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
        return
      }
      this.cancelamento.parametros.overlayBaixando = true
      let pacote = {
                      id: this.cancelamento.dados.titulo.SEQUENCIA, 
                      login:  window.localStorage.getItem('login'),
                      motivo: this.cancelamento.dados.motivo
                   }
      let uri = 'api/protected/apagar/deleteById'
      this.$http.post(uri, pacote)
      .then((response) =>{
        this.cancelamento.parametros.overlayBaixando = false
        this.$store
        .dispatch('apagar/GERAR_LISTA')
        .then(() =>{
          this.isBusyListagem = false
          this.status = true // or success
        })
      })
      .then(() =>{
        this.cancelamento.parametros.overlayBaixando = false
        this.$refs['modal-cancelamento'].hide()
        this.$root.$bvToast.toast('Título cancelado com Sucessso!!!', {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
        })
      })
      .catch(err => { 
        this.$refs['modal-cancelamento'].hide()
        this.cancelamento.parametros.overlayBaixando = false
        this.$root.$bvToast.toast('Falha! Não foi possível cancelar!!! \n ' + erro.response.data , {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
      })

    },
    colorirDiasAtraso(valor) {
      if (valor > 0) return 'danger'
      else if (valor === 0 ) return 'warning'
      else if (valor === '') return 'info'
      else 'success'
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem Contas a Pagar',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2}`,
        pageSize: 'A4',
        landscape: true,
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'contas_pagar.xls'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields,
        filename: 'contas_pagar.csv',
      });
    },
    /* ***************************************************************************************************** 
       ***********                             METODOS DO PAGAMENTO / ESTORNAR                 ***********
       *****************************************************************************************************/
    clearIntervalOverlayPagamentos() {
    },
    onShownOverlayPagamentos() {
      

      this.$refs.dialogOverlayPagamentos.focus()
    },
   
    onCancelOverlayPagamentos() {
        this.parametrosOverlayPagamento.busy = false
    },
    onAbrirOverlayPagamentos(registro) {
      this.parametrosOverlayPagamento.documento = registro.DOCUMENTO
      this.parametrosOverlayPagamento.apagarId = registro.APAGAR_ID
      this.parametrosOverlayPagamento.valor = registro.VL_PAGO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      this.parametrosOverlayPagamento.parcela = registro.PARCELAS
      this.parametrosOverlayPagamento.pagoId = registro.SEQUENCIA

      let usuario  = window.localStorage.getItem('login')
      let uri = this.$http.defaults.baseURL.concat(`api/protected/usuario/consultarpermissao?usuario=${usuario}&permissao=AcPropExcluirPagParcial`)
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
            if (data.data === true) {
              this.parametrosOverlayPagamento.permissao = true
            } else {
              this.parametrosOverlayPagamento.permissao = false
            }
            this.parametrosOverlayPagamento.processando = false
            this.parametrosOverlayPagamento.busy = true
        }
      }).catch((error) => {
        if (error) {
          this.$root.$bvToast.toast(`Falha ao consultar a permissao!!!`, {
            title: 'Falha',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
        }
        this.parametrosOverlayPagamento.processando = false
        this.parametrosOverlayPagamento.busy = false
      })
    },
    onOKOverlayPagamentos() {
      this.parametrosOverlayPagamento.busy = true
      let req = {
        pagoId:  this.parametrosOverlayPagamento.pagoId,
        apagarId: this.parametrosOverlayPagamento.apagarId,
        documento: this.parametrosOverlayPagamento.documento,
        parcela: this.parametrosOverlayPagamento.parcela,
        login: window.localStorage.getItem('login')
      }
      let uri = this.$http.defaults.baseURL.concat('api/protected/apagar/estornar')
      this.$http.post(uri, req)
      .then(response => {
        if (response.data === true) {  
          this.parametrosOverlayPagamento.busy = false
          this.$root.$bvToast.toast('Documento Baixado com Sucessso!!!', {
              title: 'Aviso',
              toaster: "b-toaster-top-center",
              autoHideDelay: 3000,
              variant: 'success',
              appendToast: true
          })
          /* Atualiza a tabela de pagamentos para estornar */
          let uriParciais = this.$http.defaults.baseURL.concat(`api/protected/pago/listarpagamentostitulo?apagarId=${req.apagarId}&documento=${req.documento}&parcela=${req.parcela}` )
          this.$http.get(uriParciais)
          .then((data) => {
            this.tablePagamentosItens = data.data
            if (data) {
              let i
              let total = 0.00
              for (i = 0; i < data.data.length ; i++) {
                total += data.data[i].VL_PAGO
              }
              this.somaTotalPago = total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
            }
            /* APLICA O FILTRO NA LISTAGEM PRINCIPAL **************************************************/ 
            this.isBusyListagem = true
             this.$store
              .dispatch('apagar/GERAR_LISTA')
              .then(() =>{
                this.isBusyListagem = false                
              }).catch((error) => {
                if (error) {
                  this.status = false
                }
              })
          })
          .catch((error) => {
            if (error) {
              this.$root.$bvToast.toast(`Falha!!!  Não foi Possível localizar os pagamentos`, {
                title: 'Falha',
                autoHideDelay: 3000,
                variant: 'danger',
                appendToast: true
              })
            }
          })
        } else {
          this.parametrosOverlayPagamento.busy = false
          this.$root.$bvToast.toast('Falha!!! Operação de estorno não executada', {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
        }
      })
      .catch((erro) => {
        this.parametrosOverlayPagamento.busy = false
        this.$root.$bvToast.toast('Falha!!! Operação de estorno não executada', {
          title: 'Aviso',
          toaster: "b-toaster-top-center",
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
      })
    },
    
    /************************************************************************************************** */
    limpar() {
      this.id = null
      this.documento = null
      this.tipoData = 'V'
      this.clienteId = null
      this.dt1 = new Date().toJSON().slice(0, 10)
      this.dt2 = new Date().toJSON().slice(0, 10)
      this.lista = []
    },

    clicarLinha(item) {
      this.tituloSelecionadoKey = this.getTituloKey(item)
      this.$store.commit("apagar/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      return this.getTituloKey(item) === this.tituloSelecionadoKey ? 'cec-row-selected' : ''
    },
    getTituloKey(item) {
      if (!item) return ''
      return [item.SEQUENCIA, item.DOCUMENTO, item.PARCELAS].map(value => value == null ? '' : String(value).trim()).join('|')
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    edit (item) {
      this.tituloSelecionadoKey = this.getTituloKey(item)
      this.$store.commit("apagar/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
      this.$router.push(`/movimentos/contasapagar/edit/${item.SEQUENCIA}`)
    },
    novo () {
      this.$router.push(`/movimentos/contasapagar/novo`)
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      const numericValue = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : value;
      if (isNaN(numericValue)) return 'R$ 0,00';
      return numericValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    async pesquisar() {
      // Previne pesquisa se o modal de confirmação estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$store.dispatch('apagar/GERAR_LISTA')
        
        // Verifica se precisa de confirmação devido ao limite de registros
        if (result.needsConfirmation) {
          // Fecha o aguardando antes de exibir o modal
          this.$store.commit('controle/setAguardando', false)
          
          // Armazena os dados para uso posterior
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          
          // Exibe o modal de confirmação
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi pesquisar os títulos' )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      
      try {
        await this.$store.dispatch('apagar/GERAR_LISTA', { skipConfirmation: true })
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Pesquisa cancelada. Refine os filtros para reduzir o resultado.')
    },
    imprimir (id) {
      this.isLoading = true
      this.submmited = true
      let uri = '/api/protected/relatorios/relvenda?id=' + id
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.isLoading = false
          this.submmited = false
          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relVenda.pdf')
          link.download = 'relVenda.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = 'Relatório de Vendas'
            }, 2000);
          }
        })
        .catch(erro => {
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
          this.isLoading = false
        })
    },
    abrirModalPagamentos(titulo) {
      this.$store.commit("apagar/SET_REGISTRO_SELECIONADO_ID", titulo.SEQUENCIA)

      let uri = this.$http.defaults.baseURL.concat(`api/protected/pago/listarpagamentostitulo?apagarId=${titulo.SEQUENCIA}&documento=${titulo.DOCUMENTO}&parcela=${titulo.PARCELAS}` )
      let promise = this.$http.get(uri)
      promise.then((data) => {
        this.tablePagamentosItens = data.data
          let i
          let total = 0.00
          this.tablePagamentosItens.forEach((value, index) => {
            total += value.VL_PAGO
          })
          this.somaTotalPago = total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          this.$refs['modal-pagamentos'].show()
      })
      .catch((error) => {
        if (error) {
          this.$root.$bvToast.toast(`Falha!!!  Não foi Possível localizar os pagamentos`, {
            title: 'Falha',
            autoHideDelay: 3000,
            variant: 'danger',
            appendToast: true
          })
        }
      })

      
    },
    async abrirModalBaixar(selecao) {
      this.$store.commit("apagar/SET_REGISTRO_SELECIONADO_ID", selecao.SEQUENCIA)
      try {
        
        this.$store.commit('controle/setAguardando', true)

        const documentoPayload = {
          documento: selecao.DOCUMENTO,
          parcela: selecao.PARCELAS,
          apagarId: selecao.SEQUENCIA
        }
        const {data} = await this.$http.post(`/api/protected/pago/getTotalByDocumentoParcela/`, documentoPayload)
        this.pago.valorPagamentos = data.total ?? 0.00

        const {data: dataAjuste} = await this.$http.get(`/api/protected/apagarAjuste/getTotalByApagarId/${selecao.SEQUENCIA}`)
        this.pago.valorAjustes = dataAjuste.total ?? 0.00,

        this.pago.apagarId = selecao.SEQUENCIA,
        this.pago.documento = selecao.DOCUMENTO,
        this.pago.parcela = selecao.PARCELAS,
        this.pago.clienteId = selecao.COD_FORNEC,
        this.pago.nomeCliente = selecao.NOME_FORNECEDOR,
        this.pago.dataVencimento = moment(String(selecao.DT_VENC)).format('DD/MM/YYYY'),
        this.pago.dataMovimento = moment(new Date()).format('YYYY-MM-DD') // new Date(dataAtual).toISOString().substr(0, 10).split('-').reverse().join('/')
        this.pago.tipoPagamento = '0',
        this.pago.valorPago = 0.00,
        
        this.pago.valorDesconto = 0.00,
        this.pago.valorAberto = selecao.VL_APAGAR,
        this.pago.valorDocumento = selecao.VL_DOC,
        this.pago.valorRestante = 0.00,
        this.pago.contaId = null,
        this.pago.vendedorId = selecao.COD_VENDEDOR
        this.pago.tipoChavePix = null
        this.pago.nomePagadorPix = null
        this.pago.bancoPixId = null
        this.pago.historicoId = null
        this.calcularPagamento()

        this.$refs['modal-baixar'].show() 
      } catch (err) {
        await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possíveld' )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async focusModalPagar() {
      this.$refs.valorPagos.$el.focus()
      this.atualizaContas()
      try {
        await this.carregarBancosPix()
        await this.carregarHistoricoPadrao()
      } catch (err) {
        console.error('Erro ao carregar dados do modal:', err)
      }
    },
    async carregarHistoricoPadrao() {
      try {
        const response = await this.$http.get('/api/protected/parametro/getHistoricosPadrao')
        if (response && response.data && response.data.ID_PLANO_BAIXA_PAGAR) {
          this.pago.historicoId = response.data.ID_PLANO_BAIXA_PAGAR
        }
      } catch (error) {
        console.error('Erro ao carregar histórico padrão:', error)
      }
    },
    usarRestante() {
      this.pago.valorPago = (this.pago.valorAberto)
    },
    calcularPagamento() {
      console.log('this.pago.valorDocumento: ', this.pago.valorDocumento ?? 0.00 )
      console.log('soma: ', ( (this.pago.valorPago ?? 0.00) + (this.pago.valorPagamentos ?? 0.0) + (this.pago.valorAjustes ?? 0.00)))
      this.pago.valorRestante = (this.pago.valorDocumento ?? 0.00) - ( (this.pago.valorPago ?? 0.00) + (this.pago.valorPagamentos ?? 0.0)) + (this.pago.valorAjustes ?? 0.00)
      console.log('valorRestante: ', this.pago.valorRestante)
    },
    baixar() {
      if ( this.validouCamposGeralBaixa === false||
           this.validouCampoMotivoMulta === false ||
           this.validouCampoMotivoDesconto === false) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        this.isLoading = false
        return
      }

      // Validação específica para PIX
      if (this.pago.tipoPagamento === '6') {
        if (!this.pago.tipoChavePix) {
          this.$root.$bvToast.toast('Informe o tipo de chave PIX!', {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
          return
        }
      }

      this.overlayBaixando = true
      let uri = this.$http.defaults.baseURL.concat('api/protected/apagarbaixa/baixar')
      this.$http.post(uri, this.pago)
      .then(response => { 
        if (!response.data) {
          throw 'falha'
        }
        this.overlayBaixando = false
        this.$root.$bvToast.toast('Documento Baixado com Sucessso!!!', {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
      })
      .then(() =>{
        this.overlayBaixando = false
        this.$store
        .dispatch('apagar/GERAR_LISTA')
        .then(() =>{
         this.overlayBaixando = false
         this.$refs['modal-baixar'].hide()
          return
        })
      })
      .catch(err => { 
        this.overlayBaixando = false
        this.$root.$bvToast.toast('Falha! Não foi possível baixar!!! \n' + err.response.data, {
            title: 'Aviso',
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
        this.overlayBaixando = false
      })
    },
    atualizaContas () {
      this.contasOpcoes = []
      this.pago.contaId = null
      let uri = this.$http.defaults.baseURL.concat('api/protected/conta/listar')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            this.contasOpcoes.push({value: data.data[i].ID, text: data.data[i].CODIGONOME})
          }
        }
      }).then(() =>{
        let uricontapadrao = this.$http.defaults.baseURL.concat('api/protected/parametro/getcontapadrao')
        let getcontapadrao = this.$http.get(uricontapadrao)
        getcontapadrao.then((data) => {
          this.pago.contaId = data.data[0].COD_CONTA
        })
      }).catch((error) => {
        if (error) {
        }
      })
    },
    async carregarBancosPix() {
      try {
        this.bancosPixOpcoes = []
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/banco-febraban/listar'))
        
        if (response && response.data) {
          for (let banco of response.data) {
            this.bancosPixOpcoes.push({ value: banco.ID, text: `${banco.ID} - ${banco.NOME}` })
          }
        }
      } catch (error) {
        console.error('Erro em carregarBancosPix:', error)
      }
    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.$refs.btAdicionar.click()
      } 
      
    }
  },
  watch: {
    'pago.valorPago': function () {
      if (this.pago.valorPago > this.pago.valorAberto) {
        this.pago.valorPago = this.pago.valorAberto
      }
      this.calcularPagamento()
    },
  },
  async created () {
    //await this.pesquisar()
  },
  async mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown);
      
    }, 200)
    this.$nextTick(() => {
      if (this.$refs.dt1) {
        if (typeof this.$refs.dt1.focus === 'function') {
          this.$refs.dt1.focus();
        } else if (this.$refs.dt1.$el && this.$refs.dt1.$el.querySelector('input')) {
          this.$refs.dt1.$el.querySelector('input').focus();
        }
      }
    })
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown);
  }
}
</script>
<style>
.negrito {
  font-weight: bold !important;
}
.campo {
  width: 25%;
  font-weight: bolder;
}
.campo-titulo {
  width: 75%;
  font-weight: bolder;
  border-style: ridge;
  border: 1px solid #c2cfd6;
  background-color: #c2cfd6 !important;
}
.campo-total-moeda {
  width: 75%;
  font-weight: bolder;
  border-style: ridge;
  border: 1px solid #c2cfd6;
  background-color: #f0f3f5 !important;
}
.negrito {
  font-weight: bolder;
}
.font-vermelha {
  color: crimson !important; 
}
.font-azul {
  color: cornflowerblue !important;
}

/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6 !important;
}

.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  background-color: #f8f9fa !important;
}

/* Estilos Premium Financeiros */
.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

</style>
<style scoped>
/* Ajustes finos para aproximar o visual da tabela ao padrão de VendaListagem */
.page-col .table.table-sm th,
.page-col .table.table-sm td {
  padding: 0.22rem 0.5rem; /* menor para reduzir altura da linha */
  vertical-align: middle;
}
.page-col .table.table-sm thead th {
  background-color: transparent; /* deixa o conteúdo em branco quando em tema claro */
}
.page-col .table.table-sm tbody tr {
  background-color: transparent !important; /* evita faixas cinza */
}
.page-col .table.table-sm tbody td {
  border-bottom: 1px solid #dcdfe0; /* linha horizontal entre registros */
}

/* opcional: enfatizar o rodapé */
.table tfoot tr td {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/contasapagar/ApagarListagem.vue